module.exports = __webpack_public_path__ + "img/22.4aa2e0b8.jpg";